import { ExpandLess, ExpandMore } from '@material-ui/icons';

import { formatCurrency } from 'utils/CurrencyUtils';

import type { HTMLAttributes } from 'react';
import type { ItemBaseOfOrderTotals } from 'shared/domain';

export function ItemOfOrderTotals(props: Props) {
  const {
    item,
    showDetail = false,
    isDetailShown = false,
    ...restProps
  } = props;
  return (
    <p aria-label={item.id} data-is-zero={item.isZero} {...restProps}>
      <span>
        {item.label}
        {showDetail && (isDetailShown ? <ExpandLess /> : <ExpandMore />)}
      </span>
      <span data-is-negative={item.isNegative}>
        {formatCurrency(item.price, false)}
      </span>
    </p>
  );
}

interface Props extends HTMLAttributes<HTMLParagraphElement> {
  item: ItemBaseOfOrderTotals;
  showDetail?: boolean;
  isDetailShown?: boolean;
}
